<template>
  <svg
    class="icon-svg"
    :class="[$attrs.class]"
    :style="svgStyle"
    aria-hidden="true"
  >
    <use :xlink:href="`${iconName}`" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Config from '@/config'

interface Props {
  icon: string
  size?: number | string
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: '#2260FF'
})

const iconfontPrefix = Config.iconfont?.prefix || 'iconfont'

const iconName = computed(() => {
  if (props.icon.startsWith('#icon-')) {
    return props.icon
  }
  return `#${props.icon}`
})

const svgStyle = computed(() => {
  const size = typeof props.size === 'number' ? `${props.size}px` : props.size
  return {
    width: size,
    height: size,
    color: props.color || '#2260FF'
  }
})
</script>

<style scoped lang="scss">
.icon-svg {
  display: inline-block;
  fill: currentColor;
  transition: fill 0.3s;
    vertical-align: -0.15em;
  overflow: hidden;

  path {
    fill: yellow;
  }
}
</style>
